import React from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { ResponsiveContext } from 'grommet';

import styles from './BottomBar.module.scss';
import { Box, Grid, Text, Image, ButtonNew } from 'components/Wrapped';
import { Copyright } from 'containers/BottomBar';
import { Logo } from 'containers/Logo';

class BottomBar extends React.Component {
  render() {
    const { exchangeName } = this.props;
    // const t = nestedTranslate(translate, 'footer');

    return (
      <ResponsiveContext.Consumer>
        {(size) => (
          <Box
            background={size === 'small' ? '#0c171f' : '#000D14'}
            align="center"
            round={false}
            pad={{
              top: size === 'small' ? '2px' : '100px',
              bottom: size === 'small' ? '18px' : '30px',
            }}
            className={styles.bottomBar}
            as="footer"
          >
            <Box pad="none" style={{ maxWidth: '1280px' }}>
              <Grid columns={size === 'small' ? { count: 1 } : ['1fr', '3fr']} gap={size === 'small' ? '3px' : '50px'} pad="none">
                <Box pad="none" width={size === 'small' ? { max: '300px', width: 'auto' } : undefined}>
                  <Box
                    margin={{
                      bottom: size === 'small' ? '15px' : '40px',
                      left: size === 'small' ? '16px' : '0px',
                    }}
                    pad="none"
                    width={{ max: '126px', width: 'auto' }}
                  >
                    <Logo navbar={true} />
                  </Box>
                  <Grid
                    columns={size === 'small' ? { count: 6, size: 'auto' } : { count: 3, size: 'auto' }}
                    gap="16px"
                    pad={size === 'small' ? '15px' : 'none'}
                  >
                    <a href="https://t.me/ibex" target="_blank" rel="noopener noreferrer">
                      <ButtonNew theme="gray" label={<Image src="/assets/social-icons/tg.svg" />} width="36px" height="36px" />
                    </a>
                  </Grid>
                </Box>
                <Box pad="none">
                  <Grid
                    columns={{ count: 2, size: 'auto' }}
                    gap={{ row: '10%', column: '45px' }}
                    pad={size === 'small' ? '20px' : 'none'}
                  >
                    <Box pad="none">
                      <Text
                        color="white"
                        size={size === 'small' ? '18px' : '21px'}
                        weight={500}
                        margin={{ bottom: '16px' }}
                        style={{ lineHeight: '22px' }}
                      >
                        Документация
                      </Text>
                      <Box pad="none" gap="20px">
                        <a href="/docs/user-agreement" target="_blank">
                          <Text color="white" style={{ textDecoration: 'underline' }}>
                            Пользовательское соглашение
                          </Text>{' '}
                        </a>
                        <a href="/docs/privacy-policy" target="_blank">
                          <Text color="white" style={{ textDecoration: 'underline' }}>
                            Политика конфиденциальности
                          </Text>{' '}
                        </a>
                        <a href="/docs/aml" target="_blank">
                          <Text color="white" style={{ textDecoration: 'underline' }}>
                            Политика по борьбе с отмыванием денег
                          </Text>{' '}
                        </a>
                      </Box>
                    </Box>
                    <Box pad="none">
                      <Text
                        color="white"
                        size={size === 'small' ? '18px' : '21px'}
                        weight={500}
                        margin={{ bottom: '16px' }}
                        style={{ lineHeight: '22px' }}
                      >
                        Контакты и поддержка
                      </Text>
                      <Box pad="none" gap="25px">
                        <a
                          href="https://t.me/ibex"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: 'inherit',
                            fontFamily: 'inherit',
                          }}
                        >
                          <Text size="small" style={{ fontWeight: '500' }}>
                            <span>
                              <Image
                                src={`/assets/social-icons/tg-default.svg`}
                                alt="Step 1"
                                width={'20px'}
                                style={{
                                  transform: 'translateY(4px)',
                                  marginRight: '5px',
                                }}
                              />
                            </span>
                            <Text size="small" style={{ fontWeight: '500' }}>
                              @ibex
                            </Text>
                          </Text>
                        </a>
                        <Text color="white" style={{ textWrap: 'wrap', maxWidth: '300px' }}>
                        </Text>{' '}
                      </Box>
                    </Box>
                    {/* <Box pad="none">
                      <Text
                        color="white"
                        size={size === 'small' ? '18px' : '21px'}
                        weight={500}
                        margin={{ bottom: '16px' }}
                        style={{ lineHeight: '22px' }}
                      >
                        About
                      </Text>
                      <Box pad="none" gap="12px">
                        {aboutLinks.map(item => (
                          <Anchor
                            key={item.label}
                            href={item.href}
                            label={item.label}
                            color="#B4B6B7"
                            className={styles.footerLink}
                          />
                        ))}
                      </Box>
                    </Box> */}

                    {/* <Box pad="none">
                      <Text
                        color="white"
                        size={size === 'small' ? '18px' : '21px'}
                        weight={500}
                        margin={{ bottom: '16px' }}
                        style={{ lineHeight: '22px' }}
                      >
                        Products
                      </Text>
                      <Box pad="none" gap="12px">
                        {productLinks.map(item => (
                          <Anchor
                            key={item.label}
                            href={item.href}
                            label={item.label}
                            color="#B4B6B7"
                            className={styles.footerLink}
                          />
                        ))}
                      </Box>
                    </Box> */}

                    {/* <Box pad="none">
                      <Text
                        color="white"
                        size={size === 'small' ? '18px' : '21px'}
                        weight={500}
                        margin={{ bottom: '16px' }}
                        style={{ lineHeight: '22px' }}
                      >
                        Services
                      </Text>
                      <Box pad="none" gap="12px">
                        {servicesLinks.map(item => (
                          <Anchor
                            key={item.label}
                            href={item.href}
                            label={item.label}
                            color="#B4B6B7"
                            className={styles.footerLink}
                          />
                        ))}
                      </Box>
                    </Box> */}

                    {/* <Box pad="none">
                      <Text
                        color="white"
                        size={size === 'small' ? '18px' : '21px'}
                        weight={500}
                        margin={{ bottom: '16px' }}
                        style={{ lineHeight: '22px' }}
                      >
                        Cryptocurrency Prices
                      </Text>
                      <Box pad="none" gap="12px">
                        {cryptoCurrLinks.map(item => (
                          <Anchor
                            key={item.label}
                            href={item.href}
                            label={item.label}
                            color="#B4B6B7"
                            className={styles.footerLink}
                          />
                        ))}
                      </Box>
                    </Box> */}
                  </Grid>
                </Box>
              </Grid>
            </Box>

            <Box
              background="#38444A"
              height="1px"
              pad="none"
              margin={{
                top: size === 'small' ? '19px' : '140px',
                bottom: size === 'small' ? '16px' : '30px',
              }}
              width={size === 'small' ? '92%' : '100%'}
              style={{ maxWidth: '1280px' }}
            />

            <Box align="center" direction="row" fill justify="between" pad="none" style={{ maxWidth: '1280px' }}>
              <Box
                align="center"
                direction="row"
                pad="none"
                gap={size === 'small' ? '10px' : '24px'}
                style={size === 'small' ? { margin: '0 auto' } : {}}
              >
                <Copyright exchangeName={exchangeName} />
                {/* <Box
                  background="#38444A"
                  pad="none"
                  height="14px"
                  width="2px"
                />
                <Anchor
                  href="#"
                  label="Privacy"
                  color="#B4B6B7"
                  className={styles.footerBottomLink}
                />
                <Anchor
                  href="#"
                  label="Cookles"
                  color="#B4B6B7"
                  className={styles.footerBottomLink}
                />
                <Anchor
                  href="#"
                  label="Terms"
                  color="#B4B6B7"
                  className={styles.footerBottomLink}
                />
                <Anchor
                  href="#"
                  label="Risk"
                  color="#B4B6B7"
                  className={styles.footerBottomLink}
                /> */}
              </Box>
              {/* {size !== 'small' && (
                  <Box direction="row" pad="none">
                    <LanguageToggler background="#19252B" isUp={true} />
                    <ThemeToggler background="#19252B" />
                  </Box>
                )} */}
            </Box>

            {/* {size === 'small' && (
                  <Box direction="row" pad="20px" gap="20px" style={{ marginTop: '20px' }}>
                    <LanguageToggler background="#19252B" isUp={true} />
                    <ThemeToggler background="#19252B" />
                  </Box>
              )} */}
          </Box>
        )}
      </ResponsiveContext.Consumer>
    );
  }
}

const mapStateToProps = ({
  exchangeSettings: {
    settings: { exchangeName, supportUrl, enableCryptoFeatures },
    contentPages,
  },
}) => ({
  exchangeName,
  contentPages,
  supportUrl,
  enableCryptoFeatures,
});

export default withNamespaces()(connect(mapStateToProps)(BottomBar));
